<template>
    <div class="score-table mt--20 mb--20" v-if="results">
        <div class="row align-items--center" v-for="n in 7">
            <div class="col-4 text--right"
                 v-bind:class="{'opacity--md': homePlayerLosTheRound(n-1) }">
                {{ homePlayerResultsForRound(n-1, 'point') }}
                <i class="material-icons" v-if="homePlayerResultsForRound(n-1, 'is_correct')">check</i>
                <i class="material-icons" v-else>close</i>
            </div>
            <div class="col-4">
                <span class="score-table__title" v-if="n==1">Question 1</span>
                <span class="score-table__title" v-else>{{ n }}</span>
            </div>
            <div class="col-4 text--left"
                 v-bind:class="{'opacity--md': awayPlayerLosTheRound(n-1) }">
                <i class="material-icons" v-if="awayPlayerResultsForRound(n-1, 'is_correct')">check</i>
                <i class="material-icons" v-else>close</i>
                {{ awayPlayerResultsForRound(n-1, 'point') }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            results: {
                default: null
            },

            homePlayer: {
                default: null,
            },

            awayPlayer: {
                default: null
            }
        },

        methods: {
            homePlayerLosTheRound(round) {
                return ! get(this.results, [this.homePlayer, round, 'is_correct'])
                    || get(this.results, [this.homePlayer, round, 'point'], 0) <  get(this.results, [this.awayPlayer, round, 'point'], 0)
            },

           awayPlayerLosTheRound(round) {
                return ! get(this.results, [this.awayPlayer, round, 'is_correct'])
                    || get(this.results, [this.awayPlayer, round, 'point'], 0) <  get(this.results, [this.homePlayer, round, 'point'], 0)
            },

            homePlayerResultsForRound(round, key) {
                return get(this.results, [this.homePlayer, round, key], 0);
            },

            awayPlayerResultsForRound(round, key) {
                return get(this.results, [this.awayPlayer, round, key], 0);
            },
        }
    }
</script>